import { useT } from '../../../../../../_metronic/i18n/Metronici18n'
import { FetchState, InfoAlert, useModal } from '../../../../../components'
import { NotaVersaoView } from '../../core/_models'
import { NotaVersaoCorpo } from '../../components/NotaVersaoCorpo'

/** Pré-visualização a partir da linha da lista, no mesmo layout que o usuário final vê. */
export const NotaVersaoPreviaModal = () => {
  const { t } = useT()
  const { fetchStates } = useModal()
  const { data: nota, isLoading, error } = (fetchStates['nota'] || {}) as FetchState<NotaVersaoView>

  if (isLoading) return null
  if (error || !nota) {
    return (
      <InfoAlert variant='danger' role='alert'>
        {t('notas_versao.historico.erro')}
      </InfoAlert>
    )
  }

  return (
    <div className='d-flex flex-column gap-4'>
      <InfoAlert variant='info' role='note'>
        {t('notas_versao.form.previa_aviso')}
      </InfoAlert>
      <NotaVersaoCorpo
        titulo={nota.titulo}
        versao={nota.versao}
        dtPublicacao={nota.dtPublicacao}
        conteudo={nota.conteudo}
      />
    </div>
  )
}
